import { Injectable } from '@angular/core';
import { PropertyDetails } from '../models/property-details';
import { Details } from '../../details/Interfaces/details';
import { DataFormatter } from '../../common/services/data-formatter.service';
import { LayoutOrientation } from '../../common/enums/layout-orientation';
import { DetailsBuilder } from '@details/Interfaces/details-builder';
import Horizontal = LayoutOrientation.Horizontal;
import { nameOnly, simple } from '@details/Interfaces/details-item-types';

@Injectable()
export class PropertyDetailsMapper {
    public map(details: PropertyDetails, dataFormatter: DataFormatter): Details {

        const b = new DetailsBuilder(`Reference ${details.Ref}`, details);

        b.section('Property', LayoutOrientation.Vertical)
            .always(nameOnly(details.Name))
            .for('Address', 'Address:');

        b.section('Key information:', Horizontal)
            .for('Tenure', 'Tenure is:')
            .conditionalItem(details.ManagementStartDate != undefined,
                simple('Management started on:', dataFormatter.formatDate(details.ManagementStartDate)))
            .conditionalItem(details.ManagementEndDate != undefined,
                simple('and will end on:', dataFormatter.formatDate(details.ManagementEndDate)))
            .conditionalItem(details.ScPeriodEndDate != undefined,
                simple('The service charge period end is:', dataFormatter.formatDate(details.ScPeriodEndDate)))
            .for('DefaultCurrency', 'Default currency used is:')
            .for('YearConstructed', 'Constructed in:');

      const formatAsLink = details.CertificateLink != null && (details.CertificateLink.startsWith('https') || details.CertificateLink.startsWith('www.'));
      let certNo = details.CertificateNo == null || details.CertificateNo == '' ? '' :
        details.CertificateNo.substring(0, 4) + ' ' + details.CertificateNo.substring(4, 8) + ' ' + details.CertificateNo.substring(8, 12)
        + ' ' + details.CertificateNo.substring(12, 16) + ' ' + details.CertificateNo.substring(16);
      b.section( 'Energy Performance:', Horizontal)
        .conditionalItem(details.EpcRatingCode == null, simple('No Current Certificate exists', null))
        .conditionalItem(details.CertificateNo, simple('Certificate No:', certNo))
        .linkForConditionalFormatting(formatAsLink, 'CertificateLink', 'Current Certificate:')
        .conditionalItem(details.EpcRatingCode, simple('Current Rating Code:', details.EpcRatingCode))
        .conditionalItem(details.PotentialRatingCode, simple('Potential Rating:', details.PotentialRatingCode))
        .conditionalItem(details.EpcExpiryDate != null, simple('Expiry Date:', dataFormatter.formatDate(details.EpcExpiryDate)))

      b.section('Additional information:', Horizontal)
            .conditionalItem(details.PropertyType, nameOnly(`This is a ${details.PropertyType} property.`))
            .conditionalItem(details.Location, nameOnly(`This property is located in ${details.Location}.`))
            .always(nameOnly(this.getVatOpted(details.VatOpted)))
            .always(nameOnly(this.getListed(details.Listed)));

        return b.getDetails();
    }

    private getVatOpted(vatOpted: string): string {
        let permitted = 'is';
        if (vatOpted.toLowerCase() !== 'y') { permitted = 'is not'; }
        return `This ${permitted} a vat opted property.`;
    }

    private getListed(listed: string): string {
        let permitted = 'is';
        if (listed.toLowerCase() !== 'y') { permitted = 'is not'; }
        return `The property ${permitted} a listed building.`;
    }
}
